// tslint:disable: typedef

import { apsDisplayEnums } from "../dto/enums";

export class App {
  static NAME = 'Anchor Glass Production System';
}

export class Endpoints {
  static SIGNALR = '/signalr';
  static POST_TOKEN = '/connect/token';
  static LINESHEET = '/api/lineSheet';
  static LINESHEET_LOCK_HOUR = '/api/lineSheet/lockHour';
  static LINESHEET_UNLOCK_HOUR = '/api/lineSheet/unlockHour';
  static DEFECT = '/api/defect';
  static DEFECT_CLASSIFICATION_LIST = '/api/defect/classifications';
  static DEFECT_COMMENT = '/api/defect/comment';
  static DEFECT_HELD_PALLETS = '/api/defect/held-pallets';
  static DEFECT_HELD_PALLETS_DELETE = '/api/defect/held-pallets/delete';
  static DEFECT_MOLD_REJECT = '/api/defect/moldReject';
  static DEFECT_MOLD_LOSS = '/api/defect/moldLossOption';
  static DEFECT_MOLD_LOSS_STATUS = '/api/defect/defectMoldLosses';
  static DEFECT_MOLD_REJECT_STATUS = '/api/defect/moldrejectstatus';
  static DEFECT_EQUIP_FAIL = '/api/defect/equipFailure';
  static DEFECT_DETAILS = '/api/defect/details';
  static DEFECT_CRITICAL_REPORT = '/api/defect/criticalReport';
  static DEFECT_LOSS_TYPES = '/api/defect/defectLossTypes';
  static DEFECT_TYPES = '/api/defect/types';
  static DEFECT_TYPES_NO_EXCLUSION = '/api/defect/types_no_exclusion';
  static DEFECT_TYPES_ALL = '/api/defect/types/all';
  static DEFECT_TYPE_DETAILS = '/api/defect/types/{0}/details';
  static DEFECT_TYPE_WARE_CLASS = '/api/Defect/Types/WareClass';
  static DEFECT_TYPE_ADD = '/api/defect/types/add';
  static DEFECT_CAUSES = '/api/Defect/Causes/{id}';
  static DEFECT_CAUSE_DETAILS = '/api/Defect/Causes/{0}/details';
  static DEFECT_CAUSE_ADD = '/api/Defect/Causes/Add';
  static DEFECT_EQUIPMENT = '/api/defectequipment';
  static ACTIVE_MNRS = '/api/defect/activemnrs';
  static DOWNTIME = '/api/Downtime';
  static DOWNTIME_TYPES = '/api/Downtime/Types';
  static DOWNTIME_SECTIONS = '/api/Downtime/Sections';
  static TOOLS_AND_TYPES = '/api/tool/toolsAndTypes';
  static SECTION_CHANGE = '/api/tool/sectionChange';
  static SECTION_CHANGE_SKIP = '/api/tool/sectionChange/skip';
  static SECTION_CHANGE_STRATEGY = '/api/sectionChange';
  static TOOL = '/api/tool';
  static TOOL_COMMENT = '/api/tool/comment'; 
  static TOOL_MOLDS = '/api/tool/molds';
  static REQUALIFICATION = '/api/requalification';
  static NOTIFICATION = '/api/notification';
  static NOTIFICATION_READ = '/api/notification/read';
  static NOTIFICATION_COMPLETE = '/api/notification/complete';
  static NEWGUID = '/api/utility/newguid';
  static SHOP = '/api/shop';
  static SHOP_CONFIGURATION = '/api/shop/configuration';
  static SHOP_DOWNTIMES = '/api/shop/{0}/downtimes/open';
  static PLANT_LISTS = '/api/plantlist';
  static CUSTOMERS = '/api/customer';
  static GLASS_COLORS = '/api/glasscolor';
  static WARE_CLASSES = '/api/wareclass';
  static JOBS = '/api/job';
  static JOB_CHANGE_ADD = '/api/jobChange';
  static JOB_PROCESSES = '/api/job/processes';
  static JOB_DESCRIPTIONS = '/api/job/descriptions';
  static JOB_MOLDS = '/api/job/molds';
  static JOB_FINISHES = '/api/job/finishes';
  static JOB_TARGET_MOLDS = '/api/job/targetmolds';
  static JOB_TARGET_FINISHES = '/api/job/targetfinishes';  
  static JOB_RUNS = '/api/jobRun';
  static JOB_RUN_RESTORE = '/api/jobrun/restore';
  static JOB_RUNS_ACTIVE = '/api/jobRun/active';
  static JOB_RUNS_TARGET = '/api/jobrun/getTargetPercent';
  static USER_ROLES = '/api/user/roles';
  static USER_ROLE_LOCATION = '/api/user/roleLocation';
  static NAVIGATION_PLANTS = '/api/navigation/plants';
  static NAVIGATION_LOCATIONS = '/api/navigation/locations';
  static HOLIDAYS = '/api/admin/holidays';
  static PLANT_LIST = '/api/admin/plants';
  static PLANT_FEATURE_SETTINGS = '/api/admin/plants/PlantFeatureSettings';
  static COURSE_OF_ACTION = '/api/Defect/Courses';
  static USERS = '/api/user';
  static USER_DATA = '/api/user/data';
  static USER_GENERATED_USERNAME = '/api/user/generatedUserName';
  static USER_CHANGE_PASSWORD = '/api/user/changePassword';
  static ROLES = '/api/role';
  static ROLES_ASSIGNABLE = '/api/role/assignable';
  static SECURITY_QUESTIONS = '/api/securityQuestion';
  static CHANGE_PASSWORD = '/api/account/changepassword';
  static USERPROFILE = '/api/userprofile';
  static RESET_PASSWORD = '/api/resetPassword';
  static SEND_RESET_PASSWORD_EMAIL = '/api/resetPassword/sendResetPasswordEmail';
  static RESET_PASSWORD_EMAIL = '/api/resetPassword/resetByEmail';
  static RESET_PASSWORD_QUESTION = '/api/resetPassword/resetBySecurityQuestion';
  static CHECKLIST = '/api/checkList';
  static CHECKLIST_COPY = '/api/checkList/copy';
  static CHECK = '/api/checkitem';
  static CHECK_OVERRIDE = '/api/checkitem/override';
  static CHECK_REORDER = '/api/checkitem/reorder';
  static CHECKLIST_OVERRIDE = '/api/checklist/override';
  static CHECKLIST_INSTANCE = '/api/checkListInstance';
  static CHECKLIST_INSTANCE_SIGNOFF = '/api/checkListInstance/signoff';
  static CHECKLIST_WELLKNOWN = '/api/checkListInstance/wellKnownCheckList';
  static CHECKLIST_WELLKNOWNCREATE = '/api/checkListInstance/WellKnownCheckListCreate';
  static CHECKLIST_INSTANCE_UNFINISHED = '/api/checkListInstance/unfinished';
  static CHECKLIST_INSTANCE_RECENT  = '/api/checkListInstance/recent';
  static CHECKLIST_REPORT = '/api/checklist/report';
  static CHECKLIST_REPORT_LISTS = '/api/checklist/reportLists';
  static CHECKLIST_REPORT_DETAIL = '/api/checklist/report/detail';
  static CHECKLIST_REPORT_HOURLY = '/api/checklist/hourlyReport';
  static CHECKLIST_LAST_RESULT = '/api/checklist/lastResult';
  static CHECKLIST_MANDATORY = '/api/checklist/isMandatory';
  static CHECKLIST_RESUBMIT_TONNAGE_CHECKS = '/api/checklist/resubmitUptimeChecks';
  static CHECKS_FAILED_FOR_PLANT = '/api/checkListInstance/failed/plant/';
  static CHECKS_FAILED_FOR_SHOP = '/api/checkListInstance/failed/shop/';
  static WELL_KNOWN_CHECKS_RESULTS = '/api/wellKnownChecks/results';
  static HOURLY_CHECKLIST_REPORT = '/api/checklist/hourlyCheckListReport';
  static NOTIFICATION_SEND = '/api/notification/send';
  static USERS_NOTIFY = '/api/user/notify';
  static DELETED_DEFECTS_REPORT = '/api/report/deletedDefects';
  static FURNACE_PULL_REPORT_SHOP = '/api/report/furnacePullShop';
  static FURNACE_PULL_REPORT_TANK = '/api/report/furnacePullTank';
  static FURNACE_PULL_REPORT_ABANDONED_WEIGHTS = '/api/report/furnacePullAbandonedWeights';
  static CRITICAL_DEFECTS_REPORT = '/api/report/criticalDefects';
  static CRITICAL_DEFECT_REPORT_DETAILS = '/api/report/criticalDefectDetails';
  static WARE_HELD_REPORT = '/api/report/wareHeld';
  static TANK_METRICS_REPORT = '/api/report/tankMetrics';
  static TOP_N_DEFECTS_REPORT = '/api/report/topDefects';
  static DEFECT_REPORT_DETAILS = '/api/report/defectDetails';
  static MORNING_MINUTES_REPORT = '/api/report/morningMinutes';
  static GENERATE_MORNING_MINUTES_REPORT = '/api/report/morningMinutes/generate';
  static SHIFT_DETAIL_REPORT = '/api/report/shiftDetail';
  static JOB_REPORT = '/api/report/jobRun';
  static JOB_REPORT_DETAILS = '/api/report/jobRunDetails';
  static DUMPGATETIME_REPORT = '/api/report/dumpgatetime';
  static PRODUCTION_REPORT = '/api/report/getProductionReport';
  static JOB_REPORT_MOLDS = '/api/report/jobRunMolds';
  static TOOL_CHANGE_REPORT = '/api/report/toolChange';
  static TOOL_CHANGE_REPORT_DETAILS = '/api/report/toolChangeDetails';
  static DOWNTIME_REPORT = '/api/report/downtimes';
  static DOWNTIME_REPORT_DETAILS = '/api/report/downtimes/details';
  static QUALIFICATIONS_REPORT = '/api/report/qualifications';
  static DEFECTS_REPORT = '/api/report/defects';
  static DEFECTS_REPORT_ALL = '/api/report/defectsAll';
  static DOWNTIME_SHIFT_REPORTV1 = '/api/report/downtimeSectionsV1';
  static DOWNTIME_SHIFT_REPORT_INSIGHT_ALL = '/api/report/downtimeInsight_All';
  static PALLET_KPIS = '/api/report/palletKpis';
  static PLANT_KPI = '/api/report/plantKpi';
  static PLANT_HOTENDBONUS = '/api/report/hotEndBonus';
  static SIGNOFF_HOTENDBONUS = '/api/report/signOffHotEndBonus';
  static GET_HOTENDBONUSSIGNOFF = '/api/report/getHotEndBonusSignOff';
  static GOB_WEIGHT_HISTORY_REPORT = '/api/report/gobWeights';
  static WEEKLY_KPI_REPORT = "/api/report/weeklyKPIs";
  static DELETED_GOB_WEIGHT_REPORT = '/api/gobWeight/deletedGobWeights';
  static CHAT = '/api/chat';
  static ALERTROLES = '/api/AlertRole';
  static LOCATIONS = '/api/location';
  static BATCH_SUMMARY = '/api/batch-summary';
  static BATCH_SUMMARY_INFO = '/api/batch-summary/bininfo';
  static BATCH_FORMULAS = '/api/batch-formulas';
  static BATCH_FORMULA_USAGES = '/api/batch-formula-usages';
  static BATCH_FORMULA_USAGE_REPORT = '/api/batch-formula-usages/report';
  static COMMODITIES = '/api/commodities';
  static COMMODITYPERCENTAGES = '/api/commodities/commoditypercentage';
  static COMMODITY_BIN = '/api/commodityBin';
  static EQUIPMENT = '/api/equipment';
  static EQUIPMENT_SHOP = '/api/equipment/shop';
  static SCALES = '/api/scales';
  static EQUIPMENT_ACTIVATE = '/api/equipment/activate';
  static EQUIPMENT_DISABLE = '/api/equipment/disable';
  static SCALE_MODE = '/api/equipment/scaleMode';
  static DATAPOINTS = '/api/dataPoint';
  static DATAPOINTS_VALIDATE = '/api/dataPoint/validate';
  static DATAPOINTS_CALCULATE = '/api/dataPoint/calculate';
  static GOB_WEIGHT_COMMENT = '/api/gobWeight/comment';
  static GOB_WEIGHT_DELETE = '/api/gobWeight/delete';
  static LINE_CONFIG = '/api/line';
  static LINE_CONFIG_TOGGLE = '/api/line/toggle';
  static LINE_CONFIG_EQUIPMENT = '/api/line/equipment';
  static LINE_CONFIG_EQUIPMENT_REORDER = '/api/line/equipment/reorder';
  static LINE_CONFIG_EQUIPMENT_TOGGLE = '/api/line/equipment/toggle';
  static LINE_CONFIG_JUNCTION = '/api/line/junction';
  static LINE_CONFIG_EQUIPMENT_NAME = '/api/line/equipment/name';
  static LINE_CONFIG_EQUIPMENT_INCONSISTENCIES = '/api/line/equipment/inconsistencies';
  static COUNTS = '/api/counts';
  static COUNTS_DETAIL = '/api/counts/detail';
  static COUNTS_GROUP_DETAIL = '/api/counts/groupDetail';
  static COUNTS_GROUP_REJECTS = '/api/counts/groupRejects';
  static COUNTS_CAVITY = '/api/counts/cavityDetail';
  static SHOP_COUNT_SUMMARY = '/api/counts/shopCountSummary';
  static SHOP_COUNT_SUMMARY_DEFECTS = '/api/counts/shopCountSummaryWithDefects';
  static CAVITY_EFFICIENCY = '/api/counts/cavityEfficiency';
  static CAVITY_CORRELATION = '/api/counts/cavityCorrelation';
  static COUNTS_DATA_POINT_HISTORY = "/api/counts/GetByDatapointID";
  static CHECK_DETECTOR_DEFECT_MAPPINGS = '/api/equipment/checkDetectorDefectMappings';
  static LINE_EQUIPMENT_NAME = '/api/line/equipment/name';
  static PALLETIZERS = '/api/equipment/palletizers';
  static EQUIPMENT_DIAGNOSTICS = '/api/equipment/diagnostics';
  static TIAMA_DEFECT_MAPPINGS = '/api/defect/tiamaMappings';
  static MACHINE_DEFECT_MAPPINGS = '/api/machineDefect/machineDefectMappings';
  static MACHINE_DEFECT_MAPPINGS_FOR_CLONING = '/api/machineDefect/machineDefectMappingsForCloning';
  static MACHINE_DEFECT_QUESTION ='/api/defect/questions';
  static TIAMA_DEFECT_MAPPINGS_DETAIL = '/api/defect/tiamaMappings/{0}/detail';
  static TIAMA_DEFECT_MAPPINGS_ADD = '/api/defect/tiamaMappings/add';
  static UPDATE_PALLETS = '/api/report/ChangeKpiPallets';
  static PACK_CHART_INFO = '/api/dashboard/packchartinfo';
  static PLANT_WARE_LOSS_DASHBOARD = '/api/dashboard/plantWareLoss';
  static PACK_PRODUCTS_INFO = '/api/dashboard/packproductsinfo';
  static PLANT_PERFORMANCE_SNAPSHOT = '/api/dashboard/snapshot';
  static FURNACE_CHART_INFO = '/api/dashboard/furnacechartinfo';
  static LINE_ITEM_HOLDS_DATA = '/api/dashboard/lineitemholds';
  static PRODUCTION_SHIFT_REPORT = '/api/report/productionShiftReport';
  static PRODUCTION_SHIFT_REPORTV2 = '/api/productionshiftreport/reportData';
  static MEASURE_MINILAB = '/api/measure/getMiniLabData';
  static MEASURE_WXG = '/api/measure/getWxgData';
  static MEASURE_PLANT_ITEMS = '/api/measure/getPlantItems';
  static PRODUCTION_SHIFT_REPORT_EXPORT = '/api/report/productionShiftReportExport';
  static PRODUCTION_SHIFT_REPORT_EXCELEXPORT = '/api/productionshiftreport/ExcelExport/';
  static DASHBOARD_SHOPSUMMARY = '/api/dashboard/shopSummary';
  static SHOP_OPERATOR_DASHBOARD = '/api/dashboard/shopOperator';
  static PRODUCTION_KPIS_DAILY = '/api/kpis/daily';
  static PRODUCTION_KPIS_MONTHLY = '/api/kpis/monthly';
  static PRODUCTION_KPIS_LAST_UPDATED_DATES = '/api/kpis/lastupdateddates';
  static FLEX_IS_DETAILS = '/api/machineDetail/FlexIsDash';
  static COUNTS_DATA_POINT_LIST = "/api/counts/GetByDatapointList";
  static DUMPGATETIME_COUNT = '/api/counts/GetDumpGateTimeCount';
  static LINE_EQUIPMENT_BY_SHOP = '/api/line/equipment/namebyshop';
  static SCORECARD = '/api/checkList/scorecardCheckListReport';
  static RELEASE_NOTE_NOTIFICATION_SEND = '/api/notification/updateReleaseNoteNotification';
  static GET_RELEASE_NOTE_NOTIFICATION = '/api/notification/getReleaseNoteNotifications';
}

export class BroadcastMessages {
  static FILL_OUT_CHECKLIST_CANCELLED = 'FILL_OUT_CHECKLIST_CANCELLED';
  static FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED = 'FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED';
  static FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT = 'FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT';
  static FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED = 'FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED';
  static FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT = 'FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT';
}

export class UIInputServiceBroadcastMessages {
  submit: string;
  cancel: string;
}

export class Enums {
  static FURNACE_PULL_VIEW_OPTIONS = [ 
    { id: 0, name: 'Tonnage by Shop' }, 
    { id: 1, name: 'Tonnage by Tank' }, 
    { id: 2, name: 'Audit' }, 
    { id: 3, name: 'Abandoned Weights' }
  ];
  
  static FREQUENCY_TYPES = {
    COUNT: {id: 1, name: 'Count'},
    XOVER4: {id: 1, name: 'X/4'},
    XOVER10: {id: 1, name: 'X/10'}
  };

  static SEVERITY = {
    Critical: {id: 0, name: 'Critical'},
    Major: {id: 1, name: 'Major'},
    Minor: {id: 2, name: 'Minor'},
    Event: {id: 3, name: 'Event'}
  };
  static TOOL_CHANGE_REASON = {
    FixDefect: {id: 0, name: 'Fix a Defect'},
    SectionChange: {id: 1, name: 'Section Change'},
    JobChange: {id: 2, name: 'Job Change'},
    Other: {id: 3, name: 'Other'}
  };
  static JOB_CHANGE_TYPE = {
    Full: {id: 1, name: 'Full'},
    Mold: {id: 2, name: 'Mold'},
    Finish: {id: 3, name: 'Finish'}
  };
  static CHECK_STATUS = {
    Failed: {id: 1, name: 'Failed'},
    Passed: {id: 2, name: 'Passed'},
    NotDone: {id: 3, name: 'Not Done'}
  };
}

export class States {
  static SIGN_IN = 'signIn';
  static RESET_PASSWORD = 'resetPassword';
  static SELECT_ROLE = 'selectRole';

  static ABSTRACT = 'aps';
  static CHECKLIST_REPORT = 'aps.checkListReport';
  static HOURLY_CHECKLIST_REPORT = 'aps.hourlyCheckListReport';
  static ADMIN_DASHBOARD = 'aps.adminDashboard';
  static PLANT_DASHBOARD = 'aps.plantDashboard';
  static GLOBAL_NOTIFICATIONS = 'aps.globalNotifications';
  static GLOBAL_NOTIFICATIONS_V2 = 'aps.globalNotificationsV2';
  static LINE_SHEET = 'aps.lineSheet';
  static DASHBOARD = 'aps.dashboard';
  static SHOP_SUMMARY_DASHBOARD = 'aps.shopSummaryDashboard';
  static PLANT_WARE_LOSS_DASHBOARD = 'aps.plantWareLossDashboard';
  static SHOP_OPERATOR_DASHBOARD = 'aps.shopOperatorDashboard';
  static JOB_RUNS = 'aps.jobRuns';
  static JOB_RUNS_V2 = 'aps.jobRunsV2';
  static JOBS = 'aps.jobs';
  static SHOPS = 'aps.shops';
  static DEFECT_TYPES = 'aps.defectTypes';
  static ALERTROLES = 'aps.alertroles';
  static COMMODITIES = 'aps.commodities';
  static BATCH_SUMMARY = 'aps.batchSummary';
  static BATCH_SUMMARY_V2 = 'aps.batchSummaryV2';
  static BATCH_FORMULAS = 'aps.batchFormulas';
  static BATCH_FORMULA_USAGES = 'aps.batchFormulaUsages';
  static BATCH_FORMULA_USAGE_REPORT = 'aps.batchFormulaUsageReport';
  static COMMODITY_BIN = 'aps.commodityBin';
  static HOLIDAYS = 'aps.holidays';
  static PLANTS = 'aps.plants';
  static PLANT_FEATURE_SETTINGS = 'aps.PlantFeatureSettings';
  static USERS = 'aps.users';
  static CHECKLISTS = 'aps.checkLists';
  static CHECKS = 'aps.checks';
  static DEFECTS_REPORT = 'aps.defectsReport';
  static DEFECTS_REPORT_V2 = 'aps.defectsReportV2';
  static DOWNTIME_REPORT_V2 = 'aps.downtimeReportV2';
  static CRITICAL_DEFECT_REPORT = 'aps.criticalDefectReport';
  static WARE_HELD_REPORT = 'aps.wareHeldReport';
  static TANK_METRICS_REPORT = 'aps.tankMetricsReport';
  static DELETED_DEFECT_REPORT = 'aps.deletedDefectReport';
  static DELETED_GOB_WEIGHT_REPORT = 'aps.deletedGobWeightReport';
  static MORNING_MINUTES_REPORT = 'aps.morningMinutesReport';
  static SHIFT_DETAIL_REPORT = 'aps.shiftDetailReport';
  static JOB_RUN_REPORT = 'aps.jobRunReport';
  static PRODUCTION_REPORT = 'aps.productionReport';
  static TOOL_CHANGE_REPORT = 'aps.toolChangeReport';
  static TOOLCHANGE_HISTORY_REPORT = 'aps.toolChangeHistoryV2';
  static HOTENDBONUS_REPORT_V2 = 'aps.hotendbonusreportV2';
  static TOP_DEFECTS_REPORT = 'aps.topDefectsReport';
  static DOWNTIME_REPORT = 'aps.downtimeReport';
  static DUMPGATETIME_REPORT = 'aps.dumpGateTimeReport';
  static FURNACE_PULL_REPORT = 'aps.furnacePullReport';
  static CHAT_REPORT = 'aps.chatReport';
  static QUALIFICATIONS_REPORT = 'aps.qualificationsReport';
  static SECTION_CHANGES = 'aps.sectionChanges';
  static EQUIPMENT = 'aps.equipment';
  static WEEKLY_KPI_REPORT = 'aps.weeklyKPIReport';
  
  static COUNTS_HORIZONTAL = 'aps.counts';
  static COUNTS_HORIZONTAL_V2 = 'aps.countsv2';
  static COUNTS_VERTICAL = 'aps.countsVertical';
  static COUNTS_VERTICAL_V2 = 'aps.countsVerticalv2';

  static COUNTS_CAVITY_CORRELATION = 'aps.countsCavityCorrelation';
  static COUNTS_CAVITY_EFFICIENCY = 'aps.countsCavityEfficiency';
  static COUNTS_DATA_POINT_HISTORY = 'aps.dataPointHistory';
  static FORMULAS = 'aps.formulas';
  static LINE_CONFIG = 'aps.lineConfig';
  static SHOP_COUNT_SUMMARY = 'aps.shopCountSummary';
  static SHOP_COUNT_SUMMARY_V2 = 'aps.shopCountSummaryV2';
  static CAVITY_EFFICIENCY = 'aps.cavityEfficiency';
  static CAVITY_CORRELATION = 'aps.cavityCorrelation';
  static CHECK_DETECTOR_DEFECT_MAPPING = 'aps.checkDetectorDefectMapping';
  static LINE_EQUIPMENT_NAMES = 'aps.lineEquipmentNames';
  static REJECT_RATE_REPORT = 'aps.rejectRateReport';
  static PALLETIZERS = 'aps.palletizers';
  static PALLETKPI = 'aps.palletKpis'
  static VIEW_DEFECT_TYPES = 'aps.viewDefectTypes';
  static VIEW_TIAMA_DEFECT_MAPPINGS = 'aps.tiamaDefectMappings';
  static VIEW_MACHINE_DEFECT_MAPPINGS = 'aps.machineDefectMappings';
  static COUNT_SUMMARY = 'aps.countSummary';
  static PLANT_PERFORMANCE = 'aps.plantPerformance';
  static PLANT_PERFORMANCE_CHARTS = 'aps.plantPerformanceCharts';
  static PRODUCTION_SHIFT_REPORT = 'aps.productionShiftReport';
  static PRODUCTION_SHIFT_REPORTV2 = 'aps.productionShiftReportV2';
  static DOWNTIME_SHIFT_REPORT = 'aps.downtimeShiftReport';
  static DOWNTIME_SHIFT_REPORT_INSIGHT = 'aps.downtimeShiftReportInsight';
  static KPIS = 'aps.kpis';
  static FLEX_IS_DETAILS = 'aps.flexIsDetails';
  static MEASURE = 'aps.measure';
  static SCORECARD = 'aps.scorecard';
  static SCORECARDV2 = 'aps.scorecardv2'; 
  static HOT_END_BONUS = 'aps.hotEndBonusReport'
}

export class Strings {
  static ISO_FORMAT = 'YYYY-MM-DDTHH:mm';
  static ISO_DATE_FORMAT = 'YYYY-MM-DD';
  static ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
  static TIME_FORMAT = 'M/D/YYYY h:mm A';
  static TIME_FORMAT_WITH_SECONDS = 'M/D/YYYY h:mm:ss A';
  static TIME_ONLY_FORMAT = 'h:mm A';
  static DATE_FORMAT = 'M/D/YYYY';
  static DEFAULT_TIMEZONE = 'US/Eastern';
}

export class Colors {
  static DEFECT_CRITICAL = '#FF0000';

  static DEFECT_MAJOR = '#ee9b02';
  static DEFECT_MINOR = '#008000';
  static DEFECT_EVENT = '#666666';
  static TOOL_CHANGE = '#336699';

  static REJECT_10 = '#C0C0C0';
  static REJECT_09 = '#909090';
  static REJECT_08 = '#606060';
  static REJECT_07 = '#303030';
  static REJECT_06 = '#000000';
  static REJECT_05 = '#330000';
  static REJECT_04 = '#660000';
  static REJECT_03 = '#990000';
  static REJECT_02 = '#CC0000';
  static REJECT_01 = '#FF0000';

  static EFFICIENCY_HIGH = '#409133';
  static EFFICIENCY_MEDIUM = '#E0AF00';
  static EFFICIENCY_LOW = '#FF6600';
  static EFFICIENCY_WARNING = '#CC0000';
}
// tslint:enable: typedef

export enum FurnacePullReportDetailTypes {
  bottlesPerMinute, tonnageWeight
}

export class Counts {
  static COUNTS_DATA: 'Counts Data';
  static CAVITY_EFFICIENCY: 'Cavity Efficiency';
  static CAVITY_CORRELATION: 'Cavity Correlation';
  static HORIZONTAL_VIEW: 'Horizontal View';
}


export class Intervals {
  static HourInSecs = 3600;

  static IntervalSeconds = {
    [apsDisplayEnums.CountDisplayInterval.CurrentHour]: Intervals.HourInSecs,
    [apsDisplayEnums.CountDisplayInterval.PreviousHour]: Intervals.HourInSecs,
    [apsDisplayEnums.CountDisplayInterval.RollingHour]: Intervals.HourInSecs,
    [apsDisplayEnums.CountDisplayInterval.CurrentShift]: Intervals.HourInSecs * 8,
    [apsDisplayEnums.CountDisplayInterval.LastShift]: Intervals.HourInSecs * 8,
    [apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast]: Intervals.HourInSecs * 8,
    [apsDisplayEnums.CountDisplayInterval.Last24Hours]: Intervals.HourInSecs * 24,
    [apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes]: Intervals.HourInSecs / 3,
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/shared/config/constant.module.ts